import React from 'react';

const CategoryTable = (props) => {
    let contents = props.contents
    return (
        <div className="keytakeaway-container__dev-section">
            <h3 className="title">{contents.title}</h3>
            <table className="dev-table">
                <thead>
                    <tr>
                        <th className="dev-table__header-cell">Lever/Category</th>
                        <th className="dev-table__header-cell">Behavior</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.map((item) => (
                        <tr key={`strength-${item.id}`}>
                            <td className={`dev-table__category-cell ${contents.className}`}>
                                {item.category}
                            </td>
                            <td className="dev-table__behavior-cell">{item.behavior}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CategoryTable;